import type { CityConfig } from "../city-template/types";

export const huberHeightsConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates — Ohio Department of Health", href: "https://odh.ohio.gov/know-our-programs/vital-statistics", description: "Official Ohio vital records office in Columbus" },
    { label: "Marriage Licenses — Montgomery County Probate Court", href: "https://www.mcohio.org/probate-court", description: "Montgomery County Probate Judge — marriage license issuance" },
    { label: "Divorce Records — Montgomery County Clerk of Courts", href: "https://www.mcohio.org/clerk-of-courts", description: "Montgomery County Clerk of Courts — divorce decree records" },
    { label: "VitalChek — Order Vital Records Online", href: "https://www.vitalchek.com/", description: "Official partner of Ohio Department of Health for online vital record orders" },
  ],
  city: "Huber Heights",
  state: "Ohio",
  stateAbbr: "OH",
  slug: "huber-heights",
  route: "/huber-heights",
  title: "Emergency Passport Huber Heights, OH — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Huber Heights, OH — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Montgomery County and the Greater Dayton area. Get your passport fast!",
  h1: "Emergency & Expedited Passport Services in Huber Heights, OH",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Huber Heights and Montgomery County travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Huber%20Heights%20Ohio%20suburban%20residential%20area%20at%20golden%20hour%20with%20modern%20family%20homes%20and%20tree-lined%20streets%2C%20well-maintained%20suburban%20neighborhoods%20with%20green%20lawns%20and%20autumn%20foliage%2C%20warm%20sunset%20light%20on%20community%20parks%20and%20local%20shops%2C%20Greater%20Dayton%20suburb%20atmosphere%20with%20wide%20boulevards%2C%20professional%20cityscape%20photography%20with%20vibrant%20warm%20colors%20and%20clear%20sky&width=1800&height=700&seq=huber-heights-oh-hero-001&orientation=landscape",
  heroImageAlt: "Huber Heights Ohio suburban residential area with modern homes at golden hour",
  geoPosition: "39.8439;-84.1247",
  geoPlacename: "Huber Heights, Ohio",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
    distance: "Located in downtown Chicago — approximately 290 miles from Huber Heights via I-70",
  },
  nearbyCitiesZips: [
    { name: "Huber Heights", zips: "45424" },
    { name: "Dayton", zips: "45401–45475" },
    { name: "Riverside", zips: "45431, 45432" },
    { name: "Vandalia", zips: "45377" },
    { name: "Trotwood", zips: "45416, 45426, 45427" },
    { name: "Englewood", zips: "45322" },
    { name: "Clayton", zips: "45315" },
    { name: "Kettering", zips: "45409, 45419, 45420, 45429, 45430, 45439, 45440, 45459" },
    { name: "Beavercreek", zips: "45410, 45430, 45431, 45432, 45434, 45440" },
    { name: "Fairborn", zips: "45324" },
    { name: "Xenia", zips: "45385" },
    { name: "Springfield", zips: "45501–45506" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Huber Heights departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-global-line", title: "Greater Dayton Coverage", desc: "Serving Montgomery County and the Dayton metropolitan area" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Dayton, OH", route: "/dayton" },
    { name: "Fast passport renewal in Kettering, OH", route: "/kettering" },
    { name: "Emergency passport help in Beavercreek, OH", route: "/beavercreek" },
    { name: "Urgent passport services in Springfield, OH", route: "/springfield-oh" },
    { name: "Same-day passport help in Columbus, OH", route: "/columbus-oh" },
    { name: "Passport courier services in Cincinnati, OH", route: "/cincinnati" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Huber Heights remotely via secure courier. We do not have a walk-in office in Huber Heights — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Montgomery County and the Greater Dayton area travelers.",
  fpcOfficeDistance: "Serving all of Montgomery County and the Greater Dayton area",
  fpcOfficeAddress: "175 S Third St, Ste 200, Columbus, Ohio 43215",
  serviceAreaIntro: "From Huber Heights to Dayton, Riverside, and Vandalia — Fast Passport Center serves the entire Montgomery County and Greater Dayton region. We regularly help travelers from Trotwood, Englewood, Clayton, and Fairborn get their passports fast.",
  nearbyCitiesIntro: "We serve all Huber Heights neighborhoods and the surrounding Montgomery County region including Dayton, Riverside, Vandalia, Trotwood, Englewood, Clayton, Kettering, Beavercreek, Fairborn, Xenia, and Springfield. If you are anywhere in the Greater Dayton metropolitan area, we have you covered.",
  howItWorksIntro: "Most Huber Heights travelers complete everything online and ship documents overnight. No need to drive to Chicago or wait in line at the regional agency.",
  mistakesIntro: "Huber Heights travelers often face long drives to the nearest regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Huber Heights and Montgomery County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Huber Heights? Here are the most common ones we hear from Montgomery County travelers.",
  statePageRoute: "/states/ohio",
  statePageName: "Ohio",
  dmvWebsite: "https://www.bmv.ohio.gov",
  dmvLabel: "Ohio BMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Huber Heights international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "James P.",
      location: "Huber Heights, OH",
      rating: 5,
      text: "My passport expired two weeks before our honeymoon in Jamaica. Fast Passport Center had my renewal ready in 4 days. They kept me informed every step and made the process so easy.",
      service: "Passport Renewal",
    },
    {
      name: "Sandra M.",
      location: "Riverside, OH",
      rating: 5,
      text: "I thought I'd have to drive to Chicago or wait weeks for an emergency passport. Fast Passport Center handled everything remotely — got mine in 48 hours. They were a lifesaver.",
      service: "Emergency Passport",
    },
    {
      name: "Chris D.",
      location: "Vandalia, OH",
      rating: 5,
      text: "Business trip to Japan came up with only 5 days notice. They got me a passport in 3 business days. Professional team and excellent communication throughout.",
      service: "Emergency Passport",
    },
    {
      name: "Rebecca K.",
      location: "Trotwood, OH",
      rating: 5,
      text: "My daughter's first passport for her school trip to France. Fast Passport Center guided us through every document, found us the nearest acceptance facility, and had her passport in 5 days.",
      service: "Child Passport",
    },
  ],
  facilities: [
    {
      id: "huber-1",
      name: "Huber Heights Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "6100 Chambersburg Rd",
      city: "Huber Heights",
      state: "OH",
      zip: "45424",
      phone: "(937) 233-4624",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Huber Heights Town Center",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Main facility serving Huber Heights and Montgomery County east suburbs. Appointments recommended. Multiple windows available.",
      icon: "ri-mail-line",
    },
    {
      id: "huber-2",
      name: "Dayton Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1111 S Main St",
      city: "Dayton",
      state: "OH",
      zip: "45409",
      phone: "(937) 225-4624",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Dayton, west of Huber Heights",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Dayton and western Montgomery County residents. Less crowded than Huber Heights. Photo services nearby.",
      icon: "ri-mail-line",
    },
    {
      id: "huber-3",
      name: "Kettering Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "3600 Wilmington Pike",
      city: "Kettering",
      state: "OH",
      zip: "45429",
      phone: "(937) 293-4624",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Kettering, south of Huber Heights",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Excellent option for southern Montgomery County residents. Easier parking than downtown Dayton.",
      icon: "ri-mail-line",
    },
    {
      id: "huber-4",
      name: "Vandalia Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "200 S Main St",
      city: "Vandalia",
      state: "OH",
      zip: "45377",
      phone: "(937) 898-4624",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Vandalia, north of Huber Heights",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Vandalia, Englewood, and northern Montgomery County residents. Ample parking. Call for appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "huber-5",
      name: "Montgomery County Clerk of Courts",
      type: "Court Clerk Passport Acceptance",
      address: "41 N Perry St",
      city: "Dayton",
      state: "OH",
      zip: "45422",
      phone: "(937) 496-7623",
      hours: "Mon–Fri: 8:00 AM – 4:00 PM",
      distance: "Montgomery County Courthouse",
      website: "https://www.mcohio.org/",
      websiteLabel: "Montgomery County Courts",
      notes: "Accepts passport applications. Good alternative to post office with extended hours and appointment availability.",
      icon: "ri-government-line",
    },
    {
      id: "huber-6",
      name: "Beavercreek Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "40 N Fairfield Rd",
      city: "Beavercreek",
      state: "OH",
      zip: "45434",
      phone: "(937) 320-4624",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Beavercreek, east of Huber Heights",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Greene County and eastern Montgomery County. Appointments required.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 5 hour drive to Chicago", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Huber Heights photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Montgomery County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Huber Heights applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Montgomery County families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Huber Heights travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Huber Heights." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Huber Heights address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Huber Heights before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Huber Heights for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 5 hour drive to Chicago." },
    { q: "How fast can I renew my passport in Huber Heights?", a: "Fast Passport Center offers fast passport renewal in Huber Heights in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "Can I get a same-day passport appointment near Huber Heights?", a: "Same-day passport appointments are only available at the Chicago Regional Passport Agency — approximately 290 miles from Huber Heights — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Montgomery County residents." },
    { q: "Can I expedite a child passport in Huber Heights?", a: "Yes. Fast Passport Center expedites child passports in Huber Heights for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Montgomery County families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Huber Heights with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "What is the closest passport agency to Huber Heights?", a: "The nearest regional passport agency to Huber Heights is the Chicago Passport Agency, approximately 290 miles away via I-70. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Huber Heights without any in-person agency visit required." },
    { q: "Do I need to drive to the Chicago Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
    { q: "How do I find a passport acceptance facility near Huber Heights?", a: "Montgomery County has several passport acceptance facilities including the Huber Heights Post Office, Dayton Main Post Office, Kettering Post Office, Vandalia Post Office, Beavercreek Post Office, and the Montgomery County Clerk of Courts. We can help you locate the most convenient facility and schedule your appointment." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Huber Heights", address: "5570 Old Troy Pike, Huber Heights, OH 45424", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/store-locator/cvs-pharmacy-photo", websiteLabel: "CVS Photo" },
    { name: "Walgreens — Huber Heights", address: "6400 Brandt Pike, Huber Heights, OH 45424", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/storelocator", websiteLabel: "Walgreens Photo" },
    { name: "Walmart Supercenter — Huber Heights", address: "7680 Brandt Pike, Huber Heights, OH 45424", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/store/finder", websiteLabel: "Walmart Photo" },
    { name: "Rite Aid — Huber Heights", address: "5650 Old Troy Pike, Huber Heights, OH 45424", hours: "Mon–Sun: 8AM–10PM", website: "https://www.riteaid.com/locations/search", websiteLabel: "Rite Aid Photo" },
    { name: "CVS Pharmacy — Dayton", address: "1111 S Main St, Dayton, OH 45409", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/store-locator/cvs-pharmacy-photo", websiteLabel: "CVS Photo" },
    { name: "Walgreens — Kettering", address: "3600 Wilmington Pike, Kettering, OH 45429", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/storelocator", websiteLabel: "Walgreens Photo" },
    { name: "Walmart — Vandalia", address: "200 S Main St, Vandalia, OH 45377", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/store/finder", websiteLabel: "Walmart Photo" },
    { name: "CVS Pharmacy — Beavercreek", address: "40 N Fairfield Rd, Beavercreek, OH 45434", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/store-locator/cvs-pharmacy-photo", websiteLabel: "CVS Photo" },
  ],
  dmvLocations: [
    {
      name: "Montgomery County BMV — Huber Heights",
      address: "5570 Old Troy Pike, Huber Heights, OH 45424",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver's license and REAL ID services. Appointment strongly recommended.",
      featured: true,
    },
    {
      name: "BMV License Agency — Dayton",
      address: "1111 S Main St, Dayton, OH 45409",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Alternative for Dayton and western Montgomery County residents. REAL ID available.",
      featured: false,
    },
    {
      name: "BMV License Agency — Vandalia",
      address: "200 S Main St, Vandalia, OH 45377",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Convenient for Vandalia, Englewood, and northern Montgomery County residents.",
      featured: false,
    },
    {
      name: "AAA — Huber Heights",
      address: "5570 Old Troy Pike, Huber Heights, OH 45424",
      hours: "Mon–Fri: 8AM–5:30PM, Sat: 9AM–12PM",
      note: "AAA members can renew licenses and access passport photo services at this location.",
      featured: true,
    },
  ],
  airports: [
    {
      code: "DAY",
      name: "Dayton International Airport",
      distance: "10 miles west of Huber Heights",
      address: "3600 Terminal Dr, Dayton, OH 45377",
      note: "Major regional airport with flights to major U.S. hubs and international connections. Most convenient for Huber Heights travelers.",
      flightUrl: "https://flydayton.com/",
      flightLabel: "Dayton Airport",
      featured: true,
    },
    {
      code: "CVG",
      name: "Cincinnati/Northern Kentucky International Airport",
      distance: "65 miles south of Huber Heights",
      address: "3087 Terminal Dr, Hebron, KY 41048",
      note: "Major international hub with direct flights to Europe, Mexico, and the Caribbean. Alternative for south Montgomery County travelers.",
      flightUrl: "https://www.cvgairport.com/",
      flightLabel: "CVG Airport",
      featured: false,
    },
    {
      code: "CMH",
      name: "John Glenn Columbus International Airport",
      distance: "75 miles northeast of Huber Heights",
      address: "4600 International Gateway, Columbus, OH 43219",
      note: "Larger hub with additional international routes. Consider for long-haul international trips.",
      flightUrl: "https://www.flycmh.com/",
      flightLabel: "Columbus Airport",
      featured: false,
    },
  ],
};